import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CircleIconButton } from 'ui/CircleIconButton';
import ChevronRightIcon from 'ui/Icons/tabler/chevron-right.component.svg';
import TrashIcon from 'ui/Icons/tabler/trash.component.svg';
import { EBankTransactionProcessingStatus, isDebit, IBankTransactionDetailLocationState } from '../types';

interface IActionsCellProps {
  transactionUuid: string;
  amountCents: number;
  processingStatus: EBankTransactionProcessingStatus;
  onDelete: (uuid: string, status: EBankTransactionProcessingStatus) => void;
  canDelete: boolean;
}

export const ActionsCell: React.FC<IActionsCellProps> = ({
  transactionUuid,
  amountCents,
  processingStatus,
  onDelete,
  canDelete,
}) => {
  const location = useLocation();

  const handleDeleteClick = () => {
    onDelete(transactionUuid, processingStatus);
  };

  // Route to payment page for debit transactions, receipt page for credit transactions
  const detailPath = isDebit(amountCents)
    ? `/finance/bank-transactions/payment/${transactionUuid}`
    : `/finance/bank-transactions/receipt/${transactionUuid}`;

  // Preserve current URL (with filters) for back navigation
  const returnUrl = `${location.pathname}${location.search}`;
  const locationState: IBankTransactionDetailLocationState = { returnUrl };

  return (
    <span className="flex items-center justify-end gap-[15px]">
      {/* Separator */}
      <span className="w-1 h-[30px] bg-gray-10 rounded" />

      {/* Detail page */}
      <Link to={{ pathname: detailPath, state: locationState }}>
        <CircleIconButton type="secondary" IconComponent={ChevronRightIcon} />
      </Link>

      {/* Delete button - only visible to admin and finance users */}
      {canDelete && (
        <CircleIconButton type="secondary" IconComponent={TrashIcon} onClick={handleDeleteClick} />
      )}
    </span>
  );
};
